import React from 'react'
import Box from '@mui/material/Box'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'

import { tokenSelectObjectType } from 'src/util/types'

export default function TokenSelect({
  value,
  handleChange,
  className,
  userTokens,
}: {
  value: string
  handleChange: (token: string) => void
  className?: string
  userTokens: tokenSelectObjectType[]
}) {
  return userTokens?.length > 0 ? (
    <Box sx={{ minWidth: 120, height: 44 }} className={className}>
      <FormControl fullWidth sx={{ height: '100%' }}>
        <InputLabel
          id="demo-simple-select-label"
          sx={{
            color: '#fff',
            fontFamily: 'Space Grotesk, sans-serif',

            '&.Mui-focused': {
              color: '#fff',
            },
          }}>
          Select token
        </InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="token-select"
          value={value || userTokens[0]?.name}
          label="Select Token"
          onChange={(e) => handleChange(e.target.value)}
          autoWidth={true}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: '12rem',
                width: '200px',
                background: 'rgba(34, 39, 66, 1)',
                color: '#fff',
              },
            },
          }}
          sx={{
            height: '100%',
            color: '#fff',
            fontFamily: 'Space Grotesk, sans-serif',
            width: '200px',
            marginRight: '1rem',

            '& .MuiSelect-icon': {
              color: '#fff',
            },

            '& .MuiSelect-root': {
              fontFamily: 'Space Grotesk, sans-serif',
              color: '#fff',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#fff',
              color: '#fff',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#fff',
              color: '#fff',
            },

            'fieldset.MuiOutlinedInput-notchedOutline': {
              borderColor: '#fff',
            },
          }}>
          {userTokens?.map((token) => (
            <MenuItem key={token?.tokenIdentifier} value={token?.name}>
              {token?.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  ) : null
}
